import DataTable from './DataTable';

export default DataTable;
export type { DataTableColumn, DataTableSort } from './DataTable';
